// frontend/src/components/Mobile/MobileRoute.jsx
// Auth + menu-permission guard for mobile pages.
//
//   <MobileRoute menuKey="mobile_fastreact_restock"><MobileRestock /></MobileRoute>
//
// - not logged in            → /mobile/login
// - logged in, no read perm  → the mobile home page (/mobile), which lists
//                              only the screens the user CAN open
// Without a menuKey it only checks authentication (e.g. for a /mobile home).

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePermissions } from '../../context/PermissionsContext';

const MobileRoute = ({ children, menuKey }) => {
  const { isAuthenticated, loading } = useAuth();
  // `loading` here must be whatever flag your PermissionsContext exposes while
  // permissions are still being fetched (same one PermissionGuard waits on);
  // without it a fresh login would flash "no access" before they arrive.
  const { can, loading: permsLoading } = usePermissions();
  const location = useLocation();

  if (loading || permsLoading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/mobile/login" state={{ from: location.pathname }} replace />;
  }

  if (menuKey && !can(menuKey, 'read')) {
    return <Navigate to="/mobile" replace />;
  }

  return children;
};

export default MobileRoute;